import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import CityDetailsPage from './pages/CityDetailsPage';

const App: React.FC = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/city/:cityId" element={<CityDetailsPage />} />
    </Routes>
  </BrowserRouter>
);

export default App;
